// Mixin containing standard event functions
// eslint-disable-next-line no-unused-vars
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import { ContentLoader } from 'vue-content-loader';
import Loader from '@/components/widgets/Loader';
import Nothing from '@/components/widgets/Nothing';
import SmartImage from '@/components/widgets/SmartImage';
import ButtonLoad from '@/components/widgets/ButtonLoad';
import AppHeader from '@/components/widgets/AppHeader';

export default {
  components: {
    ContentLoader, Loader, AppHeader, ButtonLoad, Nothing, SmartImage,
  },
  computed: {
    ...mapState('account', ['account', 'toUrl', 'fromUrl']),
    ...mapState('alert', ['alert']),
    ...mapGetters('resource', ['lookup']),
    ...mapGetters('resource', ['formOptions', 'styleOptions', 'subjectOptions', 'mediumOptions']),
    ...mapGetters('account', ['profileId', 'isVerified']),
  },
  data() {
    return {
      currencyInt: { style: 'currency', currency: 'ZAR', maximumFractionDigits: 0 },
      currencyFloat: { style: 'currency', currency: 'ZAR', maximumFractionDigits: 2 },
      client_base_url: process.env.VUE_APP_CLIENT_BASE_URL,
      artist_base_url: process.env.VUE_APP_ARTIST_BASE_URL,
      payfast_url: process.env.VUE_APP_PAYFAST_URL,
      imgproxy_url: process.env.VUE_APP_IMGPROXY_URL,
    };
  },
  methods: {
    ...mapMutations('layout', ['setLayout']),
    ...mapActions('alert', ['error', 'busy', 'success', 'clear', 'loading']),
    kebabMe(str) {
      if (str) {
        return str
          .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
          .map(x => x.toLowerCase())
          .join('-');
      }
      return '';
    },
    unKebabMe(str) {
      if (str) {
        return str
          .replace(/-/g, ' ');
      }
      return '';
    },
    formatRands(amount) {
      const amountFormatted = parseFloat(amount).toLocaleString('en-ZA', { style: 'currency', currency: 'ZAR', minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return amountFormatted;
    },
    formatRandsCents(amount) {
      const amountFormatted = parseFloat(amount).toLocaleString('en-ZA', { style: 'currency', currency: 'ZAR', maximumFractionDigits: 2 });
      return amountFormatted;
    },
    getImageUrl(imageUrl, width = 0) {
      if (imageUrl) {
        return `${this.imgproxy_url}/sig/width:${width}/${btoa(imageUrl)}.webp`;
      }
      return '';
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/standardMix.js